import { render, staticRenderFns } from "./Quote.vue?vue&type=template&id=7db0ff18&scoped=true"
import script from "./Quote.vue?vue&type=script&lang=js"
export * from "./Quote.vue?vue&type=script&lang=js"
import style0 from "./Quote.vue?vue&type=style&index=0&id=7db0ff18&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db0ff18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7db0ff18')) {
      api.createRecord('7db0ff18', component.options)
    } else {
      api.reload('7db0ff18', component.options)
    }
    module.hot.accept("./Quote.vue?vue&type=template&id=7db0ff18&scoped=true", function () {
      api.rerender('7db0ff18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/Quote.vue"
export default component.exports